import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ShopperSocialGroupCreatePage } from "./../shopper-social-group-create/shopper-social-group-create";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { ShopperSocialGroupJoinScanPage } from "../shopper-social-group-join-scan/shopper-social-group-join-scan";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-shopper-social-group",
  templateUrl: "shopper-social-group.html",
})
export class ShopperSocialGroupPage {
  theme = 1;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // console.log('ionViewDidLoad ShopperSocialGroupPage');
  }

  create() {
    this.navCtrl.push(ShopperSocialGroupCreatePage);
  }

  join() {
    this.navCtrl.push(ShopperSocialGroupJoinScanPage);
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group/shopper-social-group.ts